<template>
  <Modal :id="'cmp-settings-money-details-form'" @cancelled="onCancel">
    <template slot="header">{{$t('i18n_entry')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'textkey'"
          v-bind="textFieldConfig"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          :value="i18nEntry.textkey"
          :placeholder="$t('textkey')"
          @valuechanged="onTextFieldValueChange"
          @validated="(e, vr) => onValidationDone('textkey', vr)"
        />
        <Dropdown
          class="dt-dropdown"
          :options="sectionsTV"
          :selected="sectionsTV.find(e => e.value == i18nEntry.i18n_section)"
          box
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          :placeholder="$t('section')"
          v-on:selectedChange="e => onDropdownChange('i18n_section', e)"
          :listHeight="150"
          @validated="(vr) => onValidationDone('i18n_section', vr)"
        ></Dropdown>
        <TextField
          class="m1"
          v-for="lang of language_listTV"
          :key="lang.value"
          :id="lang.value"
          v-bind="textFieldConfig"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          :value="i18nEntry[lang.value]"
          :placeholder="$t(lang.value)"
          @valuechanged="onTextFieldValueChange"
          @validated="(e, vr) => onValidationDone(lang.value, vr)"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        @click.stop="onFormSubmit"
        class="dt-button v1 s6"
        :class="{
          'disabled': !isFormValid(),
        }"
        :disabled="!isFormValid()"
      >{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { createFormModalMixin, createFormItemMixin } from "../../../../dt-plugins/form-modal/form-modal";
import { LabelSettingsService } from "../../services/label-settings.service";
import { getVatTypes } from "../../models/invoice-line.model";
import { createTextFieldConfig } from "../../../../plugins/text-field";

export default {
  components: {
    Modal
  },
  props: ["language_listTV", "sectionsTV"],
  mixins: [createFormModalMixin()],
  data: function() {
    return {
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      }),

      formValidation: {},

      i18nEntry: this.get_i18nEntry()
    };
  },
  computed: {},
  methods: {
    get_i18nEntry: function() {
      return {
        textkey: "",
        i18n_section: "",
        en: "",
        de: "",
        fr: "",
        be: "",
        it: "",
        es: "",
        nl: "",
        pt: "",
        tr: ""
      };
    },
    onValidationDone: function(id, validationResult) {
      this.formValidation = {
        ...this.formValidation,
        [id]: validationResult
      };
    },
    isFormValid: function() {
      return Object.keys(this.formValidation)
        .map(key => this.formValidation[key].valid)
        .every(e => e);
    },
    onTextFieldValueChange: function(name, value) {
      this.i18nEntry[name] = value;
    },
    onDropdownChange: function(name, value) {
      // if (value && value.value) {
      //   }
        this.i18nEntry[name] = value.value;
    },
    onFormSubmit: function() {
      this.$emit('added', this.i18nEntry);
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-money-details-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    // margin-left: 0px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
